import { useState } from 'react';
import { observer } from 'mobx-react';

import { ChangeDispensaryModal } from './ChangeDispensaryModal';
import {
  ChangeDispensaryStore,
  ChangeDispensaryStoreProvider,
} from './ChangeDispensaryStore';

export const ChangeDispensaryWrapper = observer(
  ({ userId }: { userId: string }) => {
    // The dispensary list is app-wide state, already provided higher up the
    // tree (GlobalStores); no need to fetch a second copy of it here. Only
    // the dialog's own selection state is scoped to this instance.
    const [changeDispensaryStore] = useState(() => new ChangeDispensaryStore());

    return (
      <ChangeDispensaryStoreProvider store={changeDispensaryStore}>
        <ChangeDispensaryModal userId={userId} />
      </ChangeDispensaryStoreProvider>
    );
  },
);
